/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { renderIconByLabel } from '../../content/icons';

export const ConditionRound = props => {
  const { condition, updateField, fieldInGrid, canInteract = true } = props;

  const wrapperRef = useRef(null);
  const [circleSize, setCircleSize] = useState(0);
  const iconName = condition?.[condition?.state]?.icon;
  const circleRef = useRef(null);
  const [iconSize, setIconSize] = useState(50);

  useEffect(() => {
    if (!circleRef?.current) {
      return;
    }
    const { offsetWidth, offsetHeight } = circleRef.current;
    const visualSize = Math.min(offsetWidth, offsetHeight);
    setIconSize(Math.max(16, Math.floor(visualSize * 0.6)));
  }, [circleSize]);

  const iconElement = iconName
    ? renderIconByLabel(iconName, { size: iconSize })
    : null;
  const label = condition?.[condition?.state]?.label;

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) {
      return undefined;
    }
    const gridItem =
      wrapper.closest('.react-grid-item') ||
      wrapper.closest('[data-grid-item]') ||
      wrapper;

    const computeSize = () => {
      const rect = gridItem.getBoundingClientRect();
      const nextSize = Math.max(0, Math.min(rect.width, rect.height) - 8);
      setCircleSize(nextSize);
    };

    computeSize();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', computeSize);
      return () => window.removeEventListener('resize', computeSize);
    }

    const observer = new ResizeObserver(computeSize);
    observer.observe(gridItem);
    return () => observer.disconnect();
  }, [fieldInGrid]);

  return (
    <div
      className='w-full h-full flex items-center justify-center'
      ref={wrapperRef}
    >
      <div
        ref={circleRef}
        onClick={() =>
          canInteract &&
          updateField(
            condition.state === 'active' ? 'inactive' : 'active',
            'state'
          )
        }
        className={`rounded-full shadow flex items-center justify-center m-1 text-center uppercase font-condensed font-bold flex-shrink-0 overflow-hidden ${
          canInteract ? 'cursor-pointer transition hover:opacity-50' : 'cursor-default'
        } ${
          condition?.state === 'active' ? 'bg-secondary-d' : 'bg-primary'
        }`}
        style={{
          width: circleSize,
          height: circleSize,
          minWidth: circleSize,
          maxWidth: circleSize,
          minHeight: circleSize,
          maxHeight: circleSize,
        }}
      >
        {iconElement ? iconElement : label}
      </div>
    </div>
  );
};
